import Axios from "axios";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { PieChart } from "../pie-chart";
import { latestMonth } from "../../utils";

/**
 * The bar chart under "Latest Month" counts REC_DATE across the month two
 * months back — see `barChart()` in the server's fault.service.ts. The pie
 * chart beside it uses the month before that one; the heading names the bar
 * chart's month.
 */
const BAR_CHART_MONTHS_AGO = 2;

interface FaultOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const FaultOverview: React.FC<FaultOverviewProps> = (props) => {
  const { disableBollard, dataStartMonth } = useContext(configContext);
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/fault/overview`, { params: { from: dataStartMonth } })
      .then((res) => {
        const { lineChart, pieChart, barChart } = res.data;

        setState({
          ...state,
          lineChart: [
            { label: "Lamppost", data: lineChart[0] },
            ...(disableBollard ? [] : [{ label: "Bollard", data: lineChart[1] }]),
            { label: "Controller", data: lineChart[2] },
            { label: "Cable", data: lineChart[3] },
            { label: "GSDS", data: lineChart[4] },
          ],
          pieChart: disableBollard ? pieChart.filter((_: any, i: number) => i !== 1) : pieChart,
          barChart: [
            { label: "Lamppost", data: barChart[0] },
            ...(disableBollard ? [] : [{ label: "Bollard", data: barChart[1] }]),
            { label: "Controller", data: barChart[2] },
            { label: "Cable", data: barChart[3] },
            { label: "GSDS", data: barChart[4] },
          ],
          loading: false,
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">fault overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}

        <div style={{ width: "100%", height: "300px" }}>
          <Spin spin={state.loading}>
            <LineChart data={state.lineChart} />
          </Spin>
        </div>
      </div>

      <div>
        <span className="title">
          Latest Month <span className="month">&mdash; {latestMonth(BAR_CHART_MONTHS_AGO)}</span>
        </span>
        <div className="latest">
          <div className="left">
            <Spin spin={state.loading}>
              <PieChart
                data={state.pieChart}
                labels={["Lamppost", ...(disableBollard ? [] : ["Bollard"]), "Controller", "Cable", "GSDS"]}
              />
            </Spin>
          </div>

          <div className="right">
            <Spin spin={state.loading}>
              <BarChart data={state.barChart} />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};
